import clsx from 'clsx';
import { HiPhoto as PhotoIcon } from 'react-icons/hi2';

export function Article<T extends React.ElementType = 'article'>({
  as,
  className,
  children,
}: Omit<React.ComponentPropsWithoutRef<T>, 'as' | 'className'> & {
  as?: T;
  className?: string;
}) {
  let Component = as ?? 'article';

  return <Component className={className}>{children}</Component>;
}

Article.Content = function ArticleContent<T extends React.ElementType = 'div'>({
  as,
  className,
  children,
}: Omit<React.ComponentPropsWithoutRef<T>, 'as' | 'className'> & {
  as?: T;
  className?: string;
}) {
  let Component = as ?? 'div';

  return (
    <Component className={clsx(className, 'prose dark:prose-invert')}>
      {children}
    </Component>
  );
};

Article.Image = function ArticleImage({
  alt,
  src,
  children,
}: {
  alt: string;
  src: string;
  children: React.ReactNode;
}) {
  return (
    <figure className="mt-8">
      <img
        alt={alt}
        src={src}
        className="aspect-video rounded-xl bg-gray-50 object-cover"
      />
      <figcaption className="mt-4 flex justify-center gap-x-2 text-sm leading-6 text-gray-500">
        <PhotoIcon
          aria-hidden="true"
          className="mt-0.5 h-5 w-5 flex-none text-zinc-500"
        />
        {children}
      </figcaption>
    </figure>
  );
};
